import { render, staticRenderFns } from "./index.vue?vue&type=template&id=798f6b0f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f6b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798f6b0f')) {
      api.createRecord('798f6b0f', component.options)
    } else {
      api.reload('798f6b0f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=798f6b0f&scoped=true", function () {
      api.rerender('798f6b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HXLculture/index.vue"
export default component.exports